import React from "react";
import get from "lodash/get";

import { AdContainer } from "../../ads";
import ElectionWidget from "../../collection-templates/top-news-1-election/election-widget";

import Separator from "../../atoms/separator";

import StoryCard21 from "../story-card21";
import StoryCard20 from "../story-card20";
import StoryCard15 from "../story-card15";
import StoryCard17 from "../story-card17";
import TitleWithBorder from "../title-with-border";

import "./topnews-mobile.m.css";
import BudgetWidget from "../../collection-templates/top-news-1-budget/budget-widget";

function TopNewsMobile({
  stories,
  collectionName,
  collection = null,
  disableAds,
  brandspotStories,
  showElectionWidget = false,
  electionWidgetUrl = null,
  embed
}) {
  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  const AdCard = ({ id, mobile }) => {
    if (disableAds) return null;
    return (
      <div styleName="ad-wrapper">
        <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
      </div>
    );
  };

  brandspotStories[0] && stories.splice(9, 0, brandspotStories[0]);
  brandspotStories[1] && stories.splice(10, 0, brandspotStories[1]);

  return (
    <>
      <TitleWithBorder name={collectionName} />
      <div styleName={`wrapper ${showElectionWidget ? "election-theme" : ""}`}>
        <div styleName="section-one">
          <div styleName="big-story">
            {showElectionWidget ? (
              <div className="election-widget-wrapper">
                <ElectionWidget story={stories[0]} electionWidgetUrl={electionWidgetUrl} />
              </div>
            ) : embed ? (
              <BudgetWidget story={stories[0]} embed={embed} />
            ) : (
              <StoryCard21 story={stories[0]} />
            )}
          </div>
          {stories?.slice(1, 4).map((item, index) => (
            <React.Fragment key={index}>
              <div styleName="small-story" key={index}>
                <StoryCard15 story={item} showSectionName={true} isTabViewEnabled={showElectionWidget ? true : false} />
              </div>
              {index === 1 ? <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} /> : null}
            </React.Fragment>
          ))}
        </div>
        <div styleName="section-two">
          {stories?.slice(4, 7).map((item, index) => (
            <div styleName="small-story" key={index}>
              <StoryCard15 story={item} isTabViewEnabled={showElectionWidget ? true : false} />
            </div>
          ))}
        </div>
        <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} />
        <div styleName="section-three">
          {stories?.slice(7, 11).map((item, index) => (
            <div styleName="small-story" key={index}>
              <StoryCard17 story={item} type="b" />
            </div>
          ))}
        </div>
        <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} />
        <div styleName="section-four">
          {stories?.slice(11, 17).map((item, index) => (
            <div styleName="small-story" key={index}>
              <StoryCard20 story={item} />
            </div>
          ))}
        </div>
      </div>
      <Separator />
    </>
  );
}

export default TopNewsMobile;
